export default {
  toast_messages: {
    google_review_uploaded: 'Arviosi on vahvistettu onnistuneesti. Sait {{points}} pistettä 😉',
  },
};
